module.exports = __webpack_public_path__ + "img/creative-cover.9f975d0b.jpg";